module.exports = __webpack_public_path__ + "img/sad-pika.299ed754.gif";